'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _LayoutDesktop = require('./LayoutDesktop');

Object.defineProperty(exports, 'LayoutDesktop', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_LayoutDesktop).default;
  }
});

var _LayoutDesktopItem = require('./LayoutDesktopItem');

Object.defineProperty(exports, 'LayoutDesktopItem', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_LayoutDesktopItem).default;
  }
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// ./~/@wh/ui-components/dist/main/components/layoutDesktop/index.js
// module id = 570
// module chunks = 0